export const SET_HUB_CONNECTION = 'SetHubConnection';
export const SET_HUB_READY = 'SetHubReady';
